import React from 'react';
import { VolumeUpIcon as HeroVolumeUpIcon } from '@heroicons/react/outline';
import { Icon, IconProps } from '../Icon';

type VolumeUpIconProps = Omit<IconProps, 'children'>;

export const VolumeUpIcon: React.FC<VolumeUpIconProps> = (props) => (
    <Icon {...props}>
        <HeroVolumeUpIcon />
    </Icon>
);
